import { useEffect } from 'react'
import useLoadingStore from '../../stores/useLoadingStore'

const useBackofficeLayout = () => {
    const loadingStore = useLoadingStore()

    useEffect(() => {
        loadingStore.setLoading(false)
    }, [])

    return {}
}

export default useBackofficeLayout
